import React from 'react';
import { useNavigate } from 'react-router-dom';
import GamePrice from './GamePrice';

function GamesBundleCard({ bundle, onPurchaseClick, isAuthenticated, ownedGameIds }) {
  const navigate = useNavigate();
  const ownsAllGames = bundle.games.every((game) => ownedGameIds.includes(game.id));
  const isOwned = ownsAllGames;

  return (
    <div className="relative min-h-[400px] overflow-hidden rounded-3xl border border-dark-border shadow-xl transition-all duration-300 hover:shadow-2xl hover:shadow-accent-blue/10 lg:min-h-[440px]">
      {bundle.image ? (
        <img
          src={bundle.image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-dark-card to-dark-surface" aria-hidden="true" />
      )}

      <div
        className="absolute inset-0 bg-gradient-to-br from-dark-bg/90 via-dark-card/82 to-dark-bg/88"
        aria-hidden="true"
      />

      <div className="relative z-10 flex min-h-[400px] flex-col p-6 lg:min-h-[440px] lg:p-8">
        <div>
          <h3 className="text-xl lg:text-2xl font-semibold text-white leading-tight">
            {bundle.title}
          </h3>
          <p className="text-white/50 text-sm mt-1.5">
            {bundle.games.length} {bundle.games.length === 1 ? 'game' : 'games'} included
          </p>
        </div>

        <div className="mt-auto flex items-end justify-between gap-4 pt-6">
          <div className="flex flex-col gap-3">
            {bundle.games.map((game) => (
              <button
                key={game.id}
                type="button"
                onClick={() => navigate(`/game/${game.id}`)}
                className="group/game w-52 sm:w-56 lg:w-64 flex-shrink-0 rounded-2xl border border-white/[0.08] bg-dark-bg/55 p-3.5 text-left backdrop-blur-md transition-all duration-200 hover:border-white/15"
              >
                <div className="aspect-[16/9] overflow-hidden rounded-xl">
                  {game.mainImage ? (
                    <img
                      src={game.mainImage}
                      alt={game.title}
                      className="w-full h-full object-cover group-hover/game:scale-105 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-white/30 text-xs">
                      No image
                    </div>
                  )}
                </div>
                <div className="mt-2 px-0.5">
                  <div className="text-white text-xs lg:text-sm font-medium leading-snug line-clamp-2">
                    {game.title}
                  </div>
                  <div className="mt-1">
                    <GamePrice game={game} size="sm" />
                  </div>
                </div>
              </button>
            ))}
          </div>

          <div className="inline-flex flex-shrink-0 items-center gap-4 rounded-2xl border border-white/[0.08] bg-dark-bg/55 px-5 py-3.5 backdrop-blur-md">
            <GamePrice bundle={bundle} size="lg" />
            <button
              onClick={() => onPurchaseClick(bundle)}
              disabled={!isAuthenticated || isOwned}
              className="rounded-xl bg-white px-6 py-3 font-semibold text-dark-bg shadow-lg shadow-black/20 transition-all duration-200 hover:bg-white/90 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {!isAuthenticated ? 'Sign In to Purchase' : isOwned ? 'Owned' : 'Purchase'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GamesBundleCard;
